import VueSelect from './components/Select.vue'
import mixins from './mixins'

export default VueSelect
export { VueSelect, mixins }
